export default __webpack_public_path__ + "static/media/lbank-listing.e793f61e.jpeg";